export { default as uSSSAgileDark } from './USSSAgile-dark.svg';
export { default as uSSSAgileWhite } from './USSSAgile-white.svg';
export const companyOverview = require('./CompanyOverview.jpg?webp');
export const companyOverview2x = require('./CompanyOverview-2x.jpg?webp');
export const companyHistory = require('./CompanyHistory.jpg?webp');
export const companyHistory2x = require('./CompanyHistory-2x.jpg?webp');
export const companyMission = require('./CompanyMission.jpg?webp');
export const companyMission2x = require('./CompanyMission-2x.jpg?webp');
export const uSSSGlance = require('./USSSGlance.jpg?webp');
export const uSSSGlance2x = require('./USSSGlance-2x.jpg?webp');
export const companyMissionBg = require('./CompanyMission-bg.png?webp');
export const companyServices = require('./CompanyServices.jpg?webp');
export const companyServices2x = require('./CompanyServices-2x.jpg?webp');
export const parallax1 = require('./parallax-1.jpg?webp');
export const parallax2 = require('./parallax-2.jpg?webp');
export const parallax3 = require('./parallax-3.jpg?webp');
export const parallax4 = require('./parallax-4.jpg?webp');
export const parallax5 = require('./parallax-5.jpg?webp');
export const parallax6 = require('./parallax-6.jpg?webp');
export const parallax7 = require('./parallax-7.jpg?webp');
